"use client";
import { Play, Volume2 } from 'lucide-react';

export default function PodcastPage() {
  return (
    <main className="max-w-7xl mx-auto px-6 py-12 flex flex-col gap-12 min-h-screen">
      <h1 className="text-4xl font-bold text-white">Wszystkie odcinki</h1>
      
      {/* Glowny Player */}
      <div className="w-full bg-[#0A101D] border border-white/10 rounded-2xl p-6 flex flex-col md:flex-row items-center gap-6 shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#D6B570]/10 rounded-full blur-[80px]"></div>
        <div className="w-32 h-32 bg-[#070B14] rounded-xl flex-shrink-0 flex items-center justify-center border border-[#D6B570]/30 shadow-lg">
          <Play size={40} className="text-[#D6B570] fill-[#D6B570]"/>
        </div>
        <div className="flex-1 w-full space-y-4 z-10">
          <div className="text-[#D6B570] text-xs font-bold uppercase tracking-widest">Teraz odtwarzane</div>
          <h2 className="text-2xl font-bold text-white">#01: Zdrada i co dalej? Legalne dowody.</h2>
          <div className="w-full flex items-center gap-4">
             <div className="flex-1 h-1.5 bg-white/10 rounded-full overflow-hidden">
                <div className="w-1/3 h-full bg-[#D6B570] rounded-full"></div>
             </div>
             <span className="text-xs text-gray-400 font-mono">15:20 / 45:00</span>
             <Volume2 size={16} className="text-gray-400"/>
          </div>
        </div>
      </div>
      
      {/* Lista archiwalna */}
      <div className="space-y-4">
         {[1,2,3,4,5].map(i => (
           <div key={i} className="p-4 bg-[#0A101D] border border-white/5 rounded-xl flex items-center justify-between hover:bg-white/5 hover:border-[#D6B570]/30 transition-all cursor-pointer">
              <div className="flex items-center gap-4">
                 <button className="w-10 h-10 rounded-full bg-[#D6B570] flex items-center justify-center shadow-lg cursor-pointer"><Play size={16} className="text-[#070B14] fill-[#070B14] ml-1"/></button>
                 <div>
                    <div className="text-sm font-bold text-white">Odcinek #{6-i}: Rozwód krok po kroku</div>
                    <div className="text-xs text-gray-500">24 Wrz 2026 • 45 min</div>
                 </div>
              </div>
           </div>
         ))}
      </div>
    </main>
  );
}
